export default __webpack_public_path__ + "static/logo-35db1ff89eefb1fea7bb9d09de3a4312.png";